import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './EmptyInactivePurchases.module.scss'
import text from 'fukku/styles/texts.module.scss'

export function EmptyInactivePurchases() {
	const { t } = useLabels()
	return (
		<div
			className={styles.container}
			data-testid='myPurchases.showHistory.noResults'
		>
			<p className={`${text.titleM} ${styles.content}`}>
				{t('myPurchases.showHistory.noResults.title')}
			</p>
			<p className={`${text.bodyM} ${styles.content}`}>
				{t('myPurchases.showHistory.noResults.subtitle')}
			</p>
		</div>
	)
}
